var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 21.0801C18.7614 21.0801 21 18.8415 21 16.0801C21 13.3187 18.7614 11.0801 16 11.0801C13.2386 11.0801 11 13.3187 11 16.0801C11 18.8415 13.2386 21.0801 16 21.0801Z",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 4.08008H10C6.68629 4.08008 4 6.76637 4 10.0801V22.0801C4 25.3938 6.68629 28.0801 10 28.0801H22C25.3137 28.0801 28 25.3938 28 22.0801V10.0801C28 6.76637 25.3137 4.08008 22 4.08008Z",
    stroke: "white",
    strokeOpacity: 0.87,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5801C23.0523 10.5801 23.5 10.1324 23.5 9.58008C23.5 9.02779 23.0523 8.58008 22.5 8.58008C21.9477 8.58008 21.5 9.02779 21.5 9.58008C21.5 10.1324 21.9477 10.5801 22.5 10.5801Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black",
    transform: "translate(0 0.0800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e1a818b2e7e558f85b391b2a9c2e515e.svg";
export { ForwardRef as ReactComponent };